import React from "react";
import { TransformadorOqt } from "..";
import { TextOqt, TextPropertyName, WrapperComponent, SwitchOqt, useDialogNodeContext } from "../..";
import { useEffect } from "react";

const sanitizeTransformValue = (value) => {
  if (!value || typeof value !== "object") return null;
  return {
    idOperacion: value.idOperacion ?? null,
    tipoTransformacion: value.tipoTransformacion ?? "FORMULA",
    valorOrigen: value.valorOrigen ?? "",
    valorDestino: value.valorDestino ?? "",
    formula: value.formula ?? "",
  };
};

const sanitizeFieldForClipboard = (field) => ({
  idParametro: field?.idParametro ?? field?.id ?? null,
  descripcion: field?.descripcion ?? "",
  nombre: field?.nombre ?? "",
  value: sanitizeTransformValue(field?.value),
});

const matchField = (targetField, sourceFields = []) => {
  if (!targetField || sourceFields.length === 0) return null;
  const byId = sourceFields.find((sourceField) => {
    if (sourceField?.idParametro === undefined || sourceField?.idParametro === null) return false;
    if (targetField?.idParametro === undefined || targetField?.idParametro === null) return false;
    return String(sourceField.idParametro) === String(targetField.idParametro);
  });
  if (byId) return byId;
  const byName = sourceFields.find((sourceField) => {
    const sourceName = sourceField?.nombre;
    const targetName = targetField?.nombre;
    if (!sourceName || !targetName) return false;
    return String(sourceName).trim().toLowerCase() === String(targetName).trim().toLowerCase();
  });
  return byName || null;
};

const clipboardCopyFields = {
  nombre: (prop) => prop, 
  descripcion: (prop) => prop, 
  transitorio: (prop) => prop, 
  fields: (prop) => {
    if (!Array.isArray(prop)) return [];
    return prop.map((field) => sanitizeFieldForClipboard(field));
  }, 
};
const clipboardPasteFields = {
  nombre: (prop) => prop, 
  descripcion: (prop) => prop, 
  transitorio: (prop) => prop, 
  fields: (prop, value) => {
    const sourceFields = Array.isArray(prop) ? prop : [];
    const targetFields = Array.isArray(value) ? value : [];
    if (targetFields.length === 0) {
      return sourceFields.map((field) => sanitizeFieldForClipboard(field));
    }
    return targetFields.map((targetField, index) => {
      const matched = matchField(targetField, sourceFields) || sourceFields[index];
      if (!matched) return targetField;
      return {
        ...targetField,
        descripcion: matched.descripcion ?? targetField.descripcion,
        value: sanitizeTransformValue(matched.value),
      };
    });
  }, 
};

export const FormNodeUI = ({fmk}) => {

  const { clipboard } = useDialogNodeContext();
  useEffect(()=>{
    clipboard.setCopyProps(clipboardCopyFields);
    clipboard.setPasteProps(clipboardPasteFields);
  }, [])

  return (
    <>
      <WrapperComponent caption="Nombre" Field={<TextPropertyName autoFocus name="nombre" formik={fmk} variant="standard" />}/>
      <WrapperComponent caption="Descripción" Field={<TextOqt name="descripcion" formik={fmk} variant="standard" multiline={true}/>}/>
      <WrapperComponent caption="Transitorio" Field={<SwitchOqt name="transitorio" formik={fmk} variant="standard" />}/>
      <TransformadorOqt name="fields" caption="Parámetros" formik={fmk} />
    </>
  )
}
